export const requiredActionsTypes = {
  GET_REQUIRED_ACTIONS_REQUEST: "GET_REQUIRED_ACTIONS_REQUEST",
  GET_REQUIRED_ACTIONS_SUCCESS: "GET_REQUIRED_ACTIONS_SUCCESS",
  GET_REQUIRED_ACTIONS_FAILURE: "GET_REQUIRED_ACTIONS_FAILURE",

  RESOLVE_REQUIRED_ACTION_REQUEST: "RESOLVE_REQUIRED_ACTION_REQUEST",
  RESOLVE_REQUIRED_ACTION_SUCCESS: "RESOLVE_REQUIRED_ACTION_SUCCESS",
  RESOLVE_REQUIRED_ACTION_FAILURE: "RESOLVE_REQUIRED_ACTION_FAILURE",
};
